import { z } from 'zod';

import { CreateLoanRow } from '@willow/types-iso';

import { getParsedFields } from '../CreateLoanCrossFieldParser';

export const validateBorrowerFields = (data: CreateLoanRow, ctx: z.RefinementCtx<CreateLoanRow>) => {
  const parsed = getParsedFields(data, [
    'primaryBorrowerDetails',
    'coBorrower1Details',
    'coBorrower2Details',
    'coBorrower3Details',
    'coBorrower4Details',
    'coBorrower5Details',
    'coBorrower6Details',
    'coBorrower7Details',
    'coBorrower8Details',
    'coBorrower9Details',
  ]);

  if (!parsed) return;

  const {
    primaryBorrowerDetails,
    coBorrower1Details,
    coBorrower2Details,
    coBorrower3Details,
    coBorrower4Details,
    coBorrower5Details,
    coBorrower6Details,
    coBorrower7Details,
    coBorrower8Details,
    coBorrower9Details,
  } = parsed;

  const borrowers = [
    { details: primaryBorrowerDetails, path: 'primaryBorrowerDetails' },
    { details: coBorrower1Details, path: 'coBorrower1Details' },
    { details: coBorrower2Details, path: 'coBorrower2Details' },
    { details: coBorrower3Details, path: 'coBorrower3Details' },
    { details: coBorrower4Details, path: 'coBorrower4Details' },
    { details: coBorrower5Details, path: 'coBorrower5Details' },
    { details: coBorrower6Details, path: 'coBorrower6Details' },
    { details: coBorrower7Details, path: 'coBorrower7Details' },
    { details: coBorrower8Details, path: 'coBorrower8Details' },
    { details: coBorrower9Details, path: 'coBorrower9Details' },
  ];

  borrowers.forEach(({ details, path }) => {
    if (details?.ficoScore != null) {
      if (!Number.isInteger(details.ficoScore) || details.ficoScore < 300 || details.ficoScore > 850) {
        ctx.addIssue({
          code: 'custom',
          message: 'Fico score must be between 300 - 850',
          path: [`${path}.ficoScore`],
        });
      }
    }
  });
};
